<template>
  <div class="language-switcher">
    <select v-model="currentLang" @change="changeLang">
      <option value="en">English</option>
      <option value="vi">Tiếng Việt</option>
      <option value="zh">中文</option>
      <option value="ja">日本語</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  data () {
    return {
      currentLang: this.$i18n.locale
    }
  },
  methods: {
    changeLang () {
      this.$i18n.locale = this.currentLang
      localStorage.setItem('lang', this.currentLang)
    }
  },
  mounted () {
    const saved = localStorage.getItem('lang')
    if (saved && saved !== this.currentLang) {
      this.currentLang = saved
      this.$i18n.locale = saved
    }
  }
}
</script>

<style scoped>
.language-switcher select {
  padding: 0.22rem 0.65rem;
  border-radius: 6px;
  border: 1px solid #0369a1;
  background: #fff;
  color: #0369a1;
  font-weight: 600;
  font-size: 0.875rem;
}
</style>
